import { useStorage } from '~Components/Storage';
import { useSelector, useStaffCan } from '~Hooks';

export const usePaymentMethods = () => {
  const staffCan = useStaffCan();

  // Get the configured payment methods
  const paymentMethods = useSelector((state) =>
    state.POSPaymentMethods.sort((a, b) => a.title.localeCompare(b.title)),
  );

  const filteredMethods = paymentMethods.filter((method) => {
    if (!staffCan.canUsePaymentMethod(method.id)) {
      return false;
    }

    return true;
  });

  // Get the storage object which houses config
  const [storageData] = useStorage();

  /**
   * Returns a string for the method that should be considered
   * default for the current setup
   * @returns string
   */
  const getDefaultMethod = (): string => {
    const hasAdyen = paymentMethods.find((method) => method.id === 'ADYEN');
    const hasIzettle = paymentMethods.find((method) => method.id === 'IZETTLE');
    const hasAdyenTerminal = Boolean(storageData?.adyenTerminals.length);

    switch (true) {
      case hasAdyen && hasAdyenTerminal:
        return 'ADYEN';
      case hasAdyen && !hasIzettle:
        return 'ADYEN';
      default:
        return 'IZETTLE';
    }
  };

  return {
    getDefaultMethod,
    all: filteredMethods,
  };
};

export default usePaymentMethods;
